module.exports = __webpack_public_path__ + "static/media/Polygon.25d9e89a.svg";